import { useState } from 'react';
import {
  Tooltip,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  DialogTitle,
  
} from '@mui/material';
import { MessageQuestion,CloseCircle } from 'iconsax-react';
import { FormattedMessage } from 'react-intl';
import useAuth from 'hooks/useAuth';
import GetStarted from 'pages/GetStarted/GetStarted';
import IconButton from 'components/@extended/IconButton';

const GettingStarted = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  
  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.5, mt: 1 }}>
      <Tooltip title={<FormattedMessage id="User Guide" />}>
        <IconButton
          color="secondary"
          variant="light"
          aria-label="open user guide"
          onClick={handleToggle}
          size="large"
          sx={{
            width: user?.type === 'student' ? '32px' : '40px',
            height: user?.type === 'student' ? '32px' : '40px',
            border: user?.type === 'student' ? '1px solid white' : undefined,
            color: 'secondary.main',
            backgroundColor: {
              lg: 'transparent',
              md: 'transparent',
              sm: user?.type === 'student' ? '#13AC9E' : 'transparent',
              xs: user?.type === 'student' ? '#13AC9E' : 'transparent'
            },
            '&:hover': {
              backgroundColor: user?.type === 'student' ? '#0f8a7e' : 'transparent'
            },
            p: 0.75
          }}
        >
          <MessageQuestion size="32" color="#000000" />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        scroll="body"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 2,
            maxHeight: '80vh',
            overflowY: 'auto',
            overflowX: 'hidden',

          }
        }}
        sx={{
          '& .MuiDialog-container': {
            alignItems: 'flex-start',
            mt: 6
          }
        }}
      >
        <DialogTitle>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseCircle size="24" color="#000000" />
          </IconButton>
        </DialogTitle>
        
        <DialogContent>
          <GetStarted />
        </DialogContent>
        
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default GettingStarted;
